module.exports = __webpack_public_path__ + "img/logo-government-6.b8f2bb34.png";